import { Flex } from '@aloft/toolkit-sui';

import { selectCalculatedMarketAdjustmentDisplay } from '../../../redux/features/selectors/calculatedMarketAdjustmentSelectors/selectCalculatedMarketAdjustment.ts';
import { selectSiteValueDisplay } from '../../../redux/features/selectors/selectSiteValue.ts';
import { selectUnadjustedSiteCostDisplay } from '../../../redux/features/selectors/selectUnadjustedSiteCost.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { RootState } from '../../../redux/types.ts';
import { ContentBlock } from '../../../components/Analysis/ColumnComponents/ContentBlock.tsx';
import { DetailLineWithValue } from '../../../components/Analysis/ColumnComponents/DetailLineWithValue.tsx';
import { TotalLine } from '../../../components/Analysis/ColumnComponents/TotalLine.tsx';
import { PLACEHOLDER } from '../../analysis/consts.ts';

export const SiteSummary = ({ id }: { id: string }) => {
  const { siteValue, siteExtraction, dateOfSaleAdjustment } = useAppSelector((state: RootState) => ({
    siteValue: selectSiteValueDisplay(state, id),
    siteExtraction: selectUnadjustedSiteCostDisplay(state, id),
    dateOfSaleAdjustment: selectCalculatedMarketAdjustmentDisplay(state, id),
  }));

  const isSubject = id === 'subject' || id === 'subjectArv';
  const extractionDisplay = isSubject ? 'N/A' : (siteExtraction ?? 'N/A');
  const dosDisplay = isSubject ? 'N/A' : (dateOfSaleAdjustment ?? 'N/A');

  return (
    <ContentBlock>
      <TotalLine label="Site" value={siteValue ?? PLACEHOLDER} />
      <Flex flexDirection="column" marginTop="0.5rem" gap="0.25rem">
        <DetailLineWithValue text="Site Extraction" value={extractionDisplay} textColor="textTertiary" />
        <DetailLineWithValue text="Date of Sale Adjustment" value={dosDisplay} textColor="textTertiary" />
      </Flex>
    </ContentBlock>
  );
};

